import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LevelAttrs } from '../types/user'

interface UserOtherAttrs {
  [key: string]: any
}

export interface User {
  userId: string
  uuid: string
  inviterId: string
  loginName: string
  nickname: string
  email: string
  phone: string
  steamId: string
  steamTradeUrl: string
  avatar: string
  otherAttrs: UserOtherAttrs
  clientSeed: string
  vipLevel: number
}

interface UserState {
  currentUser: User | null
  isLoading: boolean
  error: string | null
  levelAttrs: LevelAttrs | null
  userSkinsLength: number
  userFreeCaseNum: number
}

const initialState: UserState = {
  currentUser: {
    userId: '',
    uuid: '',
    inviterId: '',
    loginName: '',
    nickname: '',
    email: '',
    phone: '',
    steamId: '',
    steamTradeUrl: '',
    avatar: '',
    otherAttrs: {},
    clientSeed: '',
    vipLevel: 0,
  },
  isLoading: false,
  error: null,
  levelAttrs: null,
  userSkinsLength: 0,
  userFreeCaseNum: 0,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload
      state.error = null
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      state.currentUser = {
        ...state.currentUser,
        ...action.payload,
      } as User
    },
    clearUser: (state) => {
      state.currentUser = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
    setLevelAttrs: (state, action: PayloadAction<LevelAttrs>) => {
      state.levelAttrs = action.payload
    },
    setUserSkinsLength: (state, action: PayloadAction<number>) => {
      state.userSkinsLength = action.payload
    },
    setUserFreeCaseNum: (state, action: PayloadAction<number>) => {
      state.userFreeCaseNum = action.payload
    },
    setUserFreeCaseNumReduceByOne: (state) => {
      state.userFreeCaseNum = Math.max(0, state.userFreeCaseNum - 1)
    },
  },
})

export const {
  setUser,
  updateUser,
  clearUser,
  setLoading,
  setError,
  setLevelAttrs,
  setUserSkinsLength,
  setUserFreeCaseNum,
  setUserFreeCaseNumReduceByOne,
} = userSlice.actions
export default userSlice
